import ActivityOne from '@/app/activities/ActivityOne';
import { Dialog } from '@/app/components/Dialog';
import { GarminAttribution } from '@/app/components/garmin/GarminAttribution';
import type { Activity } from '@trainme/db/client';
import { FiX } from 'react-icons/fi';

type Props = {
  activity: Activity;
  isModalOpen: boolean;
  close: () => void;
};

export function CalendarDayActivityModal({
  activity,
  isModalOpen,
  close,
}: Props) {
  return (
    <Dialog
      show={isModalOpen}
      onClose={close}
      dismissible={true}
      className='w-[92vw] max-w-[92vw] lg:max-w-[1400px]'
    >
      <Dialog.Header>
        <div className='flex items-center justify-between gap-4 w-full'>
          <div className='flex items-center gap-2 flex-1'>
            <h3 className='h3 my-0'>Activity:</h3>
            <div className='flex items-center gap-2 flex-wrap'>
              <span className='text-gray-500 dark:text-gray-400'>
                {activity.name}
              </span>
              {(activity as { source?: string }).source?.includes('garmin') && (
                <GarminAttribution className='text-[9px] tracking-[0.22em]' />
              )}
            </div>
          </div>
          <div className='flex items-center gap-2'>
            <button
              onClick={close}
              className='p-2 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-full transition-colors text-gray-500 dark:text-gray-400'
              aria-label='Close'
            >
              <FiX size={20} />
            </button>
          </div>
        </div>
      </Dialog.Header>
      <Dialog.Body className='p-0 flex-1 flex flex-col overflow-hidden'>
        <ActivityOne
          activity={activity}
          className='h-full border-none shadow-none rounded-none'
        />
      </Dialog.Body>
    </Dialog>
  );
}
